import * as React from "react";

// // // //

/**
 * usePageScrollLock
 * Locks page scroll (via `overflow-hidden` on `<body>`) while `lockScroll` is
 * true. Intended for overlays like drawers and modals.
 */
export function usePageScrollLock(props: { lockScroll: boolean }) {
    const { lockScroll } = props;

    // Handle body overflow (to prevent scrolling when modal is shown)
    React.useEffect(() => {
        if (!lockScroll) {
            return;
        }

        document.body.classList.add("overflow-hidden");

        // Cleanup the class when the component is unmounted or when the lock is released
        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [lockScroll]);
}
